import { AxiosInstance, AxiosPromise } from 'axios';
import {
  ClientEndpoints,
  SearchBranchesRequest,
  SearchBranchesResponse,
} from './ClientServices.types';

export class ClientServices implements ClientEndpoints {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  searchBranches(request: SearchBranchesRequest): AxiosPromise<SearchBranchesResponse> {
    return this.instance.get(`/account/branches`, {
      params: request.queryParams,
    });
  }
}
